import { createFileRoute, redirect } from "@tanstack/react-router";
import { finalInternalPath } from "@/lib/blog-internal-links";
import { withQuery } from "@/lib/redirect-query";

// Old WordPress category path /uncategorized/<slug>/. The post lives at
// /<slug>/, or at its redirect target.
export const Route = createFileRoute("/uncategorized/$")({
  beforeLoad: ({ params, location }) => {
    const rest = (params._splat ?? "").replace(/^\/+|\/+$/g, "");
    const target = !rest || rest.includes("/") ? "/hair-loss-blog/" : finalInternalPath(`/${rest}/`);
    throw redirect({ href: withQuery(target, location.searchStr), statusCode: 301 });
  },
});
